import React from "react";
import { Link } from "react-router-dom";

import "./styles.css";

import aderezos from "../../assets/icono_aderezos.png";
import culinarios from "../../assets/icono_culinarios.png";
import infusiones from "../../assets/icono_infusiones.png";
import postres from "../../assets/icono_postres.png";

function getIcono(trivia) {
  var icono = culinarios;
  switch (trivia.icon) {
    case "aderezos": icono = aderezos; break;
    case "culinarios": icono = culinarios; break;
    case "infusiones": icono = infusiones; break;
    case "postres": icono = postres; break;
    default: icono = culinarios; break;
  }
  return icono;  
}

const Render = (props, context) => {
  if (!props.trivia) return <section className="desafios consigna pbxl" />;

  return (
    <section className="desafios consigna backgroundImage fullHeightCalc pbxl verticalCenterFlex">
      <div className="container pRel">



        <p className="cifra avenirBK white upperCase alignCenter mtl">
          {props.trivia.points} <span className="avenirL">pts</span>
        </p>
        <div className="textContainer">
        <h2 className="avenirBK white bgNone alignCenter titleSize mtm borderBottomNone ">{props.trivia.name}</h2>
        </div>
        <img src={getIcono(props.trivia)} alt={props.trivia.name} className='bgNone'/>
        <p
          className={`statusTri borderBox mha white alignCenter ${
            props.trivia.completed ? "ok" : ""
          }`}
        >
          Trivia: {props.trivia.completed ? "100" : "0"}%
        </p>

        <div className="textRegular alignCenter mha mtl">
          {props.trivia.content}
        </div>

        <ul className="btnUl unstyled">
          <li>
            <Link
              to={`/trivias/${props.trivia.id}/preguntas`}
              className="btn mha btnGold"
            >
              Comenzar
            </Link>
          </li>
          <li>
            <Link to="/trivias" className="btn white btnVolver mha">
              &lt; Volver
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/TriviasConsigna/Render.js